<nav class="vd-navbar" role="banner" aria-label="Navigation principale">
  <div class="navbar-inner">

    <!-- Burger mobile -->
    <button
      type="button"
      class="icon-btn burger"
      (click)="toggleSidebar()"
      [attr.aria-label]="'navbar.open_menu' | transloco"
    >
      <span class="material-icons-outlined">menu</span>
    </button>

    <!-- Logo + wordmark -->
    <a class="brand-link" routerLink="/Accueil" [attr.aria-label]="'navbar.brand_aria' | transloco">
      <app-brand-logo size="sm" [animated]="true" [showWordmark]="true"></app-brand-logo>
    </a>

    <!-- Search desktop — ouvre la palette globale -->
    <button
      type="button"
      class="nav-search"
      role="search"
      (click)="openGlobalSearch()"
      [attr.aria-label]="'navbar.search_aria' | transloco"
    >
      <span class="material-icons-outlined">search</span>
      <span class="nav-search-placeholder">{{ 'navbar.search_placeholder' | transloco }}</span>
      <kbd class="kbd-hint">{{ isMac() ? '⌘ K' : 'Ctrl K' }}</kbd>
    </button>

    <!-- Actions droite -->
    <div class="nav-actions">

      <!-- Recherche mobile / PWA (nav-search masqué <900px) -->
      <button
        type="button"
        class="icon-btn search-mobile"
        (click)="openGlobalSearch()"
        [title]="'navbar.search_aria' | transloco"
        [attr.aria-label]="'navbar.search_aria' | transloco"
      >
        <span class="material-icons-outlined">search</span>
      </button>

      <!-- Inbox shortcut avec badge -->
      <button
        type="button"
        class="icon-btn relative"
        (click)="goToInbox()"
        [title]="'navbar.inbox_title' | transloco"
        [attr.aria-label]="'navbar.inbox_aria' | transloco"
      >
        <span class="material-icons-outlined">forum</span>
        <span class="badge" *ngIf="inboxUnread() > 0">
          {{ inboxUnread() > 99 ? '99+' : inboxUnread() }}
        </span>
      </button>

      <!-- Notifications -->
      <div class="nav-notif-wrap">
        <button
          type="button"
          class="icon-btn relative"
          (click)="toggleNotifications()"
          [attr.aria-expanded]="notificationsOpen()"
          aria-haspopup="true"
          [attr.aria-label]="'navbar.notifications' | transloco"
        >
          <span class="material-icons-outlined">notifications</span>
          <span class="badge" *ngIf="unreadNotifications() > 0">
            {{ unreadNotifications() > 99 ? '99+' : unreadNotifications() }}
          </span>
        </button>

        <div class="nav-popover" *ngIf="notificationsOpen()" role="menu">
          <header class="popover-head">
            <span class="popover-title">{{ 'navbar.notifications' | transloco }}</span>
            <span class="popover-badge" *ngIf="unreadNotifications() > 0">
              {{ 'navbar.unread_count' | transloco: { count: unreadNotifications() } }}
            </span>
          </header>
          <ul class="popover-list">
            <li
              *ngFor="let n of notifications().slice(0, 8); trackBy: trackNotif"
              class="popover-item"
              [class.unread]="!n.is_read"
              [attr.data-tone]="notificationTone(n)"
              (click)="markNotificationRead(n.public_id!)"
            >
              <span class="dot"></span>
              <div class="item-body">
                <p>{{ n.message }}</p>
                <time>{{ formatTime(n.created_at) }}</time>
              </div>
            </li>
            <li *ngIf="notifications().length === 0" class="popover-empty">
              <span class="material-icons-outlined">notifications_off</span>
              {{ 'navbar.no_notifications' | transloco }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Language switcher -->
      <app-language-switcher></app-language-switcher>

      <!-- Theme toggle -->
      <vd-theme-toggle></vd-theme-toggle>

      <!-- Profile -->
      <div class="nav-profile-wrap">
        <button
          type="button"
          class="profile-btn"
          (click)="toggleProfile()"
          [attr.aria-expanded]="profileOpen()"
          aria-haspopup="true"
          [attr.aria-label]="'navbar.my_profile' | transloco"
        >
          <span class="avatar">{{ getInitials() }}</span>
          <span class="profile-meta">
            <strong>{{ displayName() }}</strong>
            <small>{{ displayRole() }}</small>
          </span>
          <span class="material-icons-outlined chev">expand_more</span>
        </button>

        <div class="nav-popover profile-popover" *ngIf="profileOpen()">
          <header class="popover-head profile-head">
            <span class="avatar lg">{{ getInitials() }}</span>
            <div class="profile-head-meta">
              <strong>{{ displayName() }}</strong>
              <span>{{ displayEmail() }}</span>
              <span class="role-tag">{{ displayRole() }}</span>
            </div>
          </header>
          <ul class="popover-list">
            <li class="popover-item action" (click)="goToProfile()">
              <span class="material-icons-outlined">account_circle</span>
              {{ 'navbar.my_profile' | transloco }}
            </li>
            <li class="popover-item action" (click)="goToSettings()">
              <span class="material-icons-outlined">settings</span>
              {{ 'nav.settings' | transloco }}
            </li>
            <li class="popover-item action" (click)="clearCache()">
              <span class="material-icons-outlined">refresh</span>
              {{ 'navbar.clear_cache' | transloco }}
            </li>
          </ul>
          <footer class="popover-foot">
            <button class="logout-btn" type="button" (click)="logout()">
              <span class="material-icons-outlined">logout</span>
              {{ 'common.logout' | transloco }}
            </button>
          </footer>
        </div>
      </div>
    </div>
  </div>
</nav>
